module.exports = __webpack_public_path__ + "img/yandex.77e77997.svg";